import { PaginationResult } from '../models/response/pagination-result.response';

export function toPaginatedResponse<T>(data: any): PaginationResult<T> {
  let response = new PaginationResult<T>();
  response.listOfResult = data.listOfResult;
  response.size = data.size;
  response.totalPage = data.totalPage;
  return response;
}
